import templateUrl from './message-edit.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    message: '<',
    title: '<',
    onMessageChanged: '&'
  },
  controller: class MessageEditComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    onSubmit() {
      this.onMessageChanged(
        this.EventEmitter({
          message: this.message
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/dashboard/message-edit/message-edit.component.js